import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Button from "../../components/ui/Button";
import Header from "../../components/common/Header";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const HeroSection = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const buttonRef = useRef(null);
  const bgImgRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // 1. Initial Load Animation (Fades in when page loads)
      const tl = gsap.timeline();

      tl.fromTo(
        titleRef.current,
        { y: 50, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, ease: "power3.out" },
      )
        .fromTo(
          textRef.current,
          { y: 30, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.8, ease: "power3.out" },
          "-=0.5",
        )
        .fromTo(
          buttonRef.current,
          { scale: 0.8, opacity: 0 },
          { scale: 1, opacity: 1, duration: 0.5, ease: "back.out(1.7)" },
          "-=0.3",
        );

      // 2. On Scroll Animation (Background moves or fades out)
      gsap.to(bgImgRef.current, {
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top top",
          end: "bottom top",
          scrub: true, // Smooth scrolling effect
        },
        y: 150, // Parallax effect
        opacity: 0.5,
      });
    }, sectionRef);

    return () => ctx.revert(); // Cleanup on unmount
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-[#ffffff] overflow-hidden">
      <div className="w-full max-w-[1920px] mx-auto">
        <div className="relative w-full h-[650px] md:h-[800px] lg:h-[1298px]">
          {/* Background Image with Ref */}
          <img
            ref={bgImgRef}
            src="/assets/utpannProduction/Bgcolor.png"
            alt="background"
            className="absolute top-0 right-0 w-[58%] h-[560px] md:h-[700px] lg:h-[1120px] object-cover"
          />

          <Header />

          {/* Main Content */}
          <div className="relative z-10 flex flex-col items-center gap-[10px] md:gap-[20px] mt-[80px] md:mt-[120px] lg:mt-[163px] px-4 md:px-[28px] lg:px-[56px]">
            <h1
              ref={titleRef}
              className="text-[30px] md:text-[60px] lg:text-[100px] font-[parkinsans] font-bold leading-[42px] md:leading-[84px] lg:leading-[140px] text-center text-[#343163] max-w-5xl"
            >
              Utpann Network
            </h1>
            <p
              ref={textRef}
              className="text-[14px] md:text-[18px] lg:text-[24px] font-poppins font-bold leading-[22px] md:leading-[28px] lg:leading-[38px] text-center text-[#1b0e02] max-w-[1496px]"
            >
              Building a Sustainable Agricultural Future
            </p>
            <p
              ref={textRef}
              className="text-[14px] md:text-[18px] lg:text-[24px] font-poppins font-light leading-[22px] md:leading-[28px] lg:leading-[38px] text-center text-[#1b0e02] max-w-[1496px]"
            >
              UTPANN Network is dedicated to strengthening the organic farming
              ecosystem by creating a strong and reliable distribution network
              across Gujarat. With a focus on sustainability and innovation, we
              ensure that high-quality organic fertilizers produced at our
              advanced bio-gas plants reach farmers efficiently and
              consistently.
            </p>

            {/* <div ref={buttonRef} className="hero-animated-item">
              <Button
                text="Learn More"
                text_font_size="text-[16px] sm:text-[20px] xl:text-[24px]"
                text_font_family="Parkinsans"
                text_font_weight="font-semibold"
                text_color="#1c233a"
                border_border="1px solid #1c233a"
                border_border_radius="rounded-[50px]"
                className="transition-colors duration-300"
              />
            </div> */}
          </div>

          {/* Bottom Image */}
          <div className="absolute bottom-0 left-0 w-full">
            <img
              src="/assets/utpannProduction/UtpannProductionBG.png"
              alt="farming background"
              className="w-full h-[200px] md:h-[400px] lg:h-[640px] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
